export const UPDATE_USER_CREDENTIALS = 'UPDATE_USER_CREDENTIALS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_MEMBERS = 'UPDATE_MEMBERS';
export const UPDATE_MEMBER = 'UPDATE_MEMBER';
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
